module.exports = ".container-fluid table {\n  width: 100%; }\n"